"use client";
import useSWR from "swr";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { pairPriceFetcherFunction } from "../utils";
import { POLL_PRICES_API_INTERVAL } from "config";

export const useExchangeRateFetcher = ({
  baseSymbol,
  quoteSymbol
}: {
  baseSymbol?: string;
  quoteSymbol?: string;
}) => {
  const { featureVariables } = useFeatureFlags();

  const {
    data: price,
    isLoading,
    error
  } = useSWR(
    [`${baseSymbol}${quoteSymbol}`],
    ([key]) => {
      if (!featureVariables) {
        return;
      }
      return pairPriceFetcherFunction(
        key,
        baseSymbol,
        quoteSymbol,
        featureVariables
      );
    },
    {
      refreshInterval: POLL_PRICES_API_INTERVAL
    }
  );
  const exchangeRate = price || 0;

  return {
    exchangeRate: exchangeRate,
    isLoading,
    error
  };
};
